<template>
    <div class="home-body-fourth">
        <!-- 顶部标题和搜索框 -->
        <div class="fourth-header">
            <h2 class="fourth-title">搏亿学堂</h2>
            <div class="search-box">
                <input type="text" placeholder="请输入关键词" class="search-input" v-model="keywords"
                    @keyup.enter="getBoyixuetangList">
                <button class="search-btn" @click="getBoyixuetangList">
                    <img src="../../assets/images/13.png" alt="搜索">
                </button>
            </div>
        </div>

        <!-- 分类导航 -->
        <div class="category-nav">

            <el-tabs v-model="activeFenleiName" @tab-click="handleFenleiClick" style="width: 100%;">
                <el-tab-pane :label="item.name" :name="String(item.aid)" v-for="(item, index) in topList" :key="index">
                </el-tab-pane>
            </el-tabs>
        </div>


        <!-- 内容展示区域 -->
        <div class="fourth-content">
            <el-empty description="暂无数据" v-if="articles.length == 0"></el-empty>

            <div class="article-grid" v-else>
                <div class="article-card" v-for="(article, index) in articles" :key="index" @click="goDetails(article)">
                    <div class="article-image">
                        <img src="../../assets/images/jiantou.png" >
                    </div>
                    <div class="article-content">
                        <div class="article-title">{{ article.title }}</div>
                        <!-- <div class="article-info">
                            <span class="article-views">{{ article.click_count }} 阅读</span>
                        </div> -->
                    </div>

                    <div>
                        {{ article.create_time }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeBodyFourth',
    data() {
        return {
            activeFenleiName: '',
            topList: [],
            articles: [],
            keywords: '',
        }
    },
    computed: {
        // 通过getter获取cityCode
        cityCode() {
            return this.$store.getters.getCityCode[1];
        }
    },
    watch: {
        cityCode(newVal, oldVal) {
            this.getBoyixuetangList()
        }
    },
    mounted() {
        this.getBoyixuetangTabs();
    },
    methods: {
        handleFenleiClick(tab, event) {
            console.log(tab, event);
            this.getBoyixuetangList()
        },
        getBoyixuetangTabs() {
            this.$api.getBoyixuetangTabs().then(res => {
                this.topList = res;
                this.activeFenleiName = String(res[0].aid);
                this.getBoyixuetangList()

            }).catch(err => {
                this.$message.error(err);
            })
        },
        // 获取搏亿学堂的列表
        getBoyixuetangList() {
            this.$api.getBoyixuetangList({
                keywords: this.keywords,
                region_code: this.cityCode,
                schoolcategory_id: this.activeFenleiName
            }).then(res => {
                // console.log(res, '学堂');

                this.articles = res.data;
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 跳转详情页
        goDetails(article) {
            this.$router.push({
                path: '/boyixuetang',
                query: {
                    aid: article.aid
                }
            })
        }
    }
}
</script>

<style scoped>
.home-body-fourth {
    width: 1200px;
    margin: 20px auto;
    padding: 0 20px;
}

/* 顶部标题和搜索框 */
.fourth-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 10px 20px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.fourth-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    margin: 0;
    padding-left: 10px;
    border-left: 3px solid #286CED;
}

/* 搜索框样式 - 与HomeBodyThird保持一致 */
.search-box {
    display: flex;
    align-items: center;
    border: 1px solid #e0e0e0;
}

.search-input {
    width: 200px;
    padding: 8px 15px;
    border: none;
    border-radius: 4px 0 0 4px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.3s;
}

.search-input:focus {
    border-color: #286CED;
}

.search-btn {
    padding: 8px 12px;
    background-color: #ffffff;
    color: #999;
    border: none;
    border-left: none;
    border-radius: 0 4px 4px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
}

.search-btn img {
    width: 16px;
    height: 16px;
    margin-right: 12px;
}

/* 内容展示区域 */
.fourth-content {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    padding: 20px;
}

/* 文章网格 */
.article-grid {
    /* display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px; */
    display: flex;
    flex-direction: column;
   justify-content: center;
}

/* 文章卡片 */
.article-card {
    display: flex;
    align-items: center;
    /* 使用flex布局，图片和文字横向排列 */
    background-color: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    transition: all 0.3s;
    margin-bottom: 10px;
}

.article-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

/* 文章图片 */
.article-image {
    width: 20px;
    /* 设置图片宽度为100px */
    height: 20px;
    /* 设置图片高度为72px */
    /* overflow: hidden;
    flex-shrink: 0; */
    /* 防止图片被压缩 */
}

.article-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
}

.article-card:hover .article-image img {
    transform: scale(1.05);
}

/* 文章内容区 */
.article-content {
    flex-grow: 1;
    /* 内容区占据剩余空间 */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* 标题和信息分别靠上和靠下 */
    padding: 12px;
}

/* 文章标题 */
.article-title {
    font-size: 14px;
    color: #333;
    line-height: 1.5;
    overflow: hidden;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    /* 限制显示两行 */
    -webkit-box-orient: vertical;
    /* margin-bottom: 8px; */
    text-align: left;
    /* 确保文字靠左对齐 */
}

/* 文章信息 */
.article-info {
    font-size: 12px;
    color: #999;
    text-align: left;
    /* 确保信息也靠左对齐 */
}

.article-views {
    display: flex;
    align-items: center;
}

.article-views::before {
    content: "👁️";
    margin-right: 4px;
}

/* 响应式设计 */
@media (max-width: 1200px) {
    .home-body-fourth {
        width: 100%;
    }

    .article-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .fourth-header {
        flex-direction: column;
        align-items: stretch;
        gap: 15px;
    }

    .search-input {
        width: 100%;
    }

    .article-grid {
        grid-template-columns: 1fr;
    }
}

/* 分类导航样式 */
.category-nav {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    border-radius: 0;
    /* width: 100%; */
    background-color: #fff;
    padding: 10px 10px;
}

.nav-item {
    padding: 10px 20px;
    cursor: pointer;
    color: #333;
    font-size: 14px;
    transition: all 0.3s;
}

.nav-item:hover {
    color: #286CED;
}

.nav-item.active {
    color: #286CED;
    font-weight: bold;
    position: relative;
}

.nav-item.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 2px;
    background-color: #286CED;
    border-radius: 1px;
}

/* 自定义Element UI标签页样式 */
::v-deep .el-tabs__header .is-top::after {
    background-color: transparent !important;
}
</style>